import { Text } from '@instabox/consumer-web-ui'
import Link from 'next/link'

export const RICH_TAGS = {
  br: () => <br />,
  b: (chunks: string[]) => (
    // grey bold
    <Text as="strong" fontWeight="bold" fontSize="inherit">
      {chunks}
    </Text>
  ),
  b2: (chunks: string[]) => (
    // white bold
    <Text as="strong" fontWeight="bold" fontSize="inherit" color="white">
      {chunks}
    </Text>
  ),
  i: (chunks: string[]) => (
    // grey italic
    <Text as="em" italic fontSize="inherit">
      {chunks}
    </Text>
  ),
  i2: (chunks: string[]) => (
    // white italic
    <Text as="em" italic fontSize="inherit" color="white">
      {chunks}
    </Text>
  ),
  p: (chunks: string[]) => (
    // grey  text (used to wrap multiple lines)
    <Text align="center">{chunks}</Text>
  ),
  'p-center': (chunks: string[]) => (
    // grey centered text (used to wrap multiple lines)
    <Text align="center">{chunks}</Text>
  ),
  p2: (chunks: string[]) => (
    // white  text (used to wrap multiple lines)
    <Text color="white">{chunks}</Text>
  ),
  'p2-center': (chunks: string[]) => (
    // white centered text (used to wrap multiple lines)
    <Text align="center" color="white">
      {chunks}
    </Text>
  ),
  'sms-link': (chunks: string[]) => <a href={`sms:${chunks}`}>{chunks}</a>,
  'mail-link': (chunks: string[]) => <a href={`mailto:${chunks}`}>{chunks}</a>,
  'cookies-link': (chunks: string[]) => <Link href="/cookies">{chunks}</Link>,
}
